import React, { memo } from 'react'
import styles from './ClanSupplyFooter.scss'
import classNames from 'classnames'
import { CLAN_SUPPLY_FOOTER_STATUSES, TANK_STATUSES } from '../clan_quests_constants'
import {
    CLAN_SUPPLY_PROGRESSION_CAN_OPEN_NEW_REGION,
    CLAN_SUPPLY_PROGRESSION_EXPLORE_NEW_REGIONS,
    CLAN_SUPPLY_PROGRESSION_EXPLORE_WITH_NEW_TANK,
    CLAN_SUPPLY_PROGRESSION_TANK_RECEIVED,
} from '../../translations'
import PropTypes from 'prop-types'
import { VEHICLE_TYPES } from 'constants'
import { toRoman } from 'helpers'

const getStatus = (isNewStageAvailable, isTankAcquired) => {
    if (isTankAcquired) {
        return CLAN_SUPPLY_FOOTER_STATUSES.SUCCESS
    }
    if (isNewStageAvailable) {
        return CLAN_SUPPLY_FOOTER_STATUSES.CAN_EXAMINE
    }

    return CLAN_SUPPLY_FOOTER_STATUSES.DEFAULT
}

const ClanSupplyFooterProgression = memo(({
    tankStatus,
    type,
    level,
    title,
    isNewStageAvailable,
}) => {
    return (
        <div className={classNames(styles.base, styles[`base__status-${getStatus(
            isNewStageAvailable,
            tankStatus === TANK_STATUSES.ACQUIRED,
        )}`])}
        >
            {
                isNewStageAvailable && (tankStatus !== TANK_STATUSES.ACQUIRED) &&
                <div className={styles.canExamineEffect} />
            }
            {(tankStatus === TANK_STATUSES.ACQUIRED || isNewStageAvailable) && (
                <div className={classNames(styles.iconStatus)} />
            )}
            <p className={styles.text}>
                {(() => {
                    switch (true) {
                    case tankStatus === TANK_STATUSES.AVAILABLE:
                        return CLAN_SUPPLY_PROGRESSION_EXPLORE_WITH_NEW_TANK
                    case tankStatus === TANK_STATUSES.ACQUIRED:
                        return CLAN_SUPPLY_PROGRESSION_TANK_RECEIVED(
                            <span className={styles.vehicleLevel}>{toRoman(level)}</span>,
                            <div className={classNames(styles.typeIcon, styles[`typeIcon__${type}`])} />,
                            <span className={styles.vehicleTitle}>{title}</span>,
                        )
                    case isNewStageAvailable:
                        return CLAN_SUPPLY_PROGRESSION_CAN_OPEN_NEW_REGION
                    default:
                        return CLAN_SUPPLY_PROGRESSION_EXPLORE_NEW_REGIONS
                    }
                })()}
            </p>
        </div>
    )
})

ClanSupplyFooterProgression.propTypes = {
    tankStatus: PropTypes.oneOf(Object.values(TANK_STATUSES)).isRequired,
    type: PropTypes.oneOf(Object.values(VEHICLE_TYPES)).isRequired,
    level: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    isNewStageAvailable: PropTypes.bool.isRequired,
}

export default ClanSupplyFooterProgression



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanSupplyFooter/ClanSupplyFooterProgression.jsx